import {
    IShareBaseSocket,
    RoomCountCallback,
    SocketEmitCallback,
    SocketEventCallback,
    SocketEventUnsubscribe
} from './socket-types';

export class NullShareBaseSocket implements IShareBaseSocket {
    public readonly id: string = '';
    public readonly connected: boolean = false;
    public readonly disconnected: boolean = true;

    public on<TPayload>(eventName: string, cb: SocketEventCallback<TPayload>): SocketEventUnsubscribe {
        return () => { };
    }

    public emit<TPayload>(eventName: string, payload?: TPayload, cb?: SocketEmitCallback): void {

    }

    public joinRoom(room: string, roomCountCallback: RoomCountCallback) {
        
    }

    public disconnect(): void {
        
    }
}


// WEBPACK FOOTER //
// ./src/real-time/sockets/null-sharebase-socket.ts